<template>
  <router-view />
  <Transition name="fade">
    <div v-if="toastMessage" class="toast">{{ toastMessage }}</div>
  </Transition>
  <UpdatePrompt :show="showUpdateModal" :onConfirm="applyUpdate" />
</template>

<script setup>
  // main.js 또는 App.vue의 setup() 또는 mounted()에서 실행
  //if (!window.Kakao.isInitialized()) {
  //  window.Kakao.init(import.meta.env.VITE_KAKAO_API_KEY); // REST API 키가 아님
  //}
  import { onMounted, ref, provide } from 'vue'
  import { useRoute, useRouter } from 'vue-router'
  import { useStore } from 'vuex'
  import { rewardUser } from '@/utils/setReward.js'
  import UpdatePrompt from '@/components/UpdatePrompt.vue'
  import { updateSW, onServiceWorkerUpdate } from '@/main.js'
  import { onMessage } from 'firebase/messaging'
  import { messaging } from '@/firebase.js'

  let fcmListenerRegistered = false
  const toastMessage = ref('')

  function showToast(message) {
    toastMessage.value = message
    setTimeout(() => (toastMessage.value = ''), 3000)
  }

  provide('showToast', showToast)

  const setDeviceWidth = () => {
    const width = window.innerWidth + 'px'
    document.documentElement.style.setProperty('--device-width', width)
  }

  // 업데이트 모달 관련
  const showUpdateModal = ref(false)

  function applyUpdate() {
    updateSW(true) // 새 서비스워커 적용 및 강제 새로고침
    showUpdateModal.value = false
  }

  onMounted(() => {
    setDeviceWidth()
    window.addEventListener('resize', setDeviceWidth)

    // 나를 추천한 사람의 accessToken을 기록해 둔다. (추천자 보상을 위해)
    const route = useRoute()
    const referrer = route.query.ref
    if (referrer && !localStorage.getItem('referrer')) {
      localStorage.setItem('referrer', referrer)
    }

    // 출석 보상: accessToken이 있을 때만 시도
    const store = useStore()
    const user = store.getters.getUser
    if (user?.accessToken) {
      rewardUser(
        store,
        'dailyCheckin',
        { loginDate: new Date().toISOString() },
        showToast,
      )
    }


    const router = useRouter()
    const urlParams = new URLSearchParams(window.location.search)
    const fromNotification = urlParams.get('from') === 'notification'

    if (fromNotification) {
      try {
        const dataStr = urlParams.get('data')
        const data = dataStr ? JSON.parse(dataStr) : {}
        console.log('푸시 알림으로 앱 실행됨:', data)

        // 라우터 이동 (예: 일일 기운 상세 페이지)
        router.push({ name: 'PushDetail', query: data })
      } catch (err) {
        console.error('푸시 알림 데이터 파싱 오류:', err)
      }
    }



    if (!fcmListenerRegistered) {
      fcmListenerRegistered = true
      console.log('FCM 포그라운드 리스너 등록')
      
      // 포그라운드 푸시 메시지 수신 핸들러 등록
      onMessage(messaging, (payload) => {
        console.log('Message received (foreground):', payload)

        const { title, body } = payload.notification || {}
        const { date, type } = payload.data || {}

        // data가 포함된 경우 바로 상세 페이지 이동
        if (date && type) {
          console.log('Foreground push detected, navigating to PushDetail:', { date, type })
          router.push({
            name: 'PushDetail',
            query: { date, type },
          })
        } else if (title && body) {
          // 혹시 data가 없는 단순 알림이면 기존처럼 toast 표시
          showToast(`${title}\n${body}`)
        }
      })

    }




    // PWA 업데이트 감지 핸들러 등록
    onServiceWorkerUpdate(() => {
      showUpdateModal.value = true
    })
  })

  

</script>

<style scoped>
  .toast {
    position: fixed;
    bottom: 60px;
    left: 50%;
    transform: translateX(-50%);
    background-color: #333;
    color: white;
    padding: 0.8rem 1.2rem;
    border-radius: 8px;
    font-size: var(--font-size-09);
    z-index: 1000;
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.3s;
  }
  .fade-enter-from,
  .fade-leave-to {
    opacity: 0;
  }
</style>
